"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverRender = serverRender;
exports.clientRender = clientRender;
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _server = babelHelpers.interopRequireDefault(require("react-dom/server"));

var _decorators = require("decorators");

var _jQuery = babelHelpers.interopRequireDefault(require("jQuery"));

var _class, _temp;

var ServiceForm = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ServiceForm, _Component);

  function ServiceForm() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ServiceForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ServiceForm)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.state = {
      name: "",
      phone: "",
      email: "",
      property: "",
      comments: "",
      submitting: false,
      submitted: false,
      submittedOverlayInDocument: false
    };
    return _this;
  }

  babelHelpers.createClass(ServiceForm, [{
    key: "nameChanged",
    value: function nameChanged(event) {
      this.setState({
        name: event.target.value
      });
    }
  }, {
    key: "phoneChanged",
    value: function phoneChanged(event) {
      this.setState({
        phone: event.target.value
      });
    }
  }, {
    key: "emailChanged",
    value: function emailChanged(event) {
      this.setState({
        email: event.target.value
      });
    }
  }, {
    key: "propertyChanged",
    value: function propertyChanged(event) {
      this.setState({
        property: event.target.value
      });
    }
  }, {
    key: "toggleComments",
    value: function toggleComments() {
      (0, _jQuery.default)(this.commentsField).slideToggle();
    }
  }, {
    key: "commentsChanged",
    value: function commentsChanged(event) {
      this.setState({
        comments: event.target.value
      });
    }
  }, {
    key: "gotCommentsField",
    value: function gotCommentsField(ref) {
      this.commentsField = ref;
    }
  }, {
    key: "gotSubmittedOverlay",
    value: function gotSubmittedOverlay(ref) {
      this.submittedOverlay = ref;
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      this.setState({
        submitting: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.state.submitting && !this.state.submitted) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', 'data/service-request', true);
        xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4) _this2.setState({
            submitted: true
          });
        };

        xhr.send(JSON.stringify(babelHelpers.objectSpread({
          service: this.props.service.id,
          name: this.state.name,
          phone: this.state.phone,
          email: this.state.email,
          comments: this.state.comments
        }, this.props.service.seo_url == 'Pro-Site' ? {
          property: this.state.property
        } : {})));
      }

      if (!this.state.submittedOverlayInDocument && this.submittedOverlay) {
        this.setState({
          submittedOverlayInDocument: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "services-form form".concat(this.props.service.seo_url == 'Pro-Site' ? ' prosite-form' : ''),
        style: {
          position: 'relative'
        }
      }, _react.default.createElement("h3", null, "Call", ' 503.906.' + (this.props.service.seo_url == 'Pro-Site' ? '8148 ' : '8118 '), " or contact us below"), _react.default.createElement("div", {
        className: "form-field-container col-md-8 col-xs-12"
      }, _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("input", {
        type: "text",
        className: "form-control",
        placeholder: "Name *",
        onChange: this.nameChanged,
        value: this.state.name
      })), _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("input", {
        type: "text",
        className: "form-control",
        placeholder: "Phone Number *",
        onChange: this.phoneChanged,
        value: this.state.phone
      })), _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("input", {
        type: "text",
        className: "form-control",
        placeholder: "Email Address *",
        onChange: this.emailChanged,
        value: this.state.email
      })), this.props.service.seo_url == 'Pro-Site' ? _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("input", {
        type: "text",
        className: "form-control",
        placeholder: "Property / Facility Name",
        onChange: this.propertyChanged,
        value: this.state.property
      })), _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("textarea", {
        rows: 3,
        className: "form-control",
        onChange: this.commentsChanged,
        placeholder: "Comments",
        value: this.state.comments
      }))) : _react.default.createElement(_react.Fragment, null, _react.default.createElement("a", {
        className: "add-comments-link",
        href: "javascript:void(0)",
        onClick: this.toggleComments
      }, "+ Add Comments"), _react.default.createElement("div", {
        ref: this.gotCommentsField,
        className: "form-group comments-field"
      }, _react.default.createElement("textarea", {
        rows: 3,
        className: "form-control",
        onChange: this.commentsChanged,
        value: this.state.comments
      })))), _react.default.createElement("button", {
        className: "btn submit-form-btn",
        disabled: this.formInvalid || this.state.submitting,
        onClick: this.submitForm
      }, "Send Request"), this.state.submitted ? _react.default.createElement("div", {
        ref: this.gotSubmittedOverlay,
        style: {
          position: 'absolute',
          background: '#ededed',
          opacity: this.state.submittedOverlayInDocument ? 1 : 0,
          transition: '.3s ease',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, _react.default.createElement("h1", null, "Thank you for your submission!"), _react.default.createElement("p", null, "We will be in contact with you soon about ", this.props.service.title, ".")) : null);
    }
  }, {
    key: "formInvalid",
    get: function get() {
      return !this.state.name || !this.state.phone || !this.state.email;
    }
  }]);
  return ServiceForm;
}(_react.Component), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "nameChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "nameChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "phoneChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "phoneChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "emailChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "emailChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "propertyChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "propertyChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "toggleComments", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "toggleComments"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "commentsChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "commentsChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotCommentsField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotCommentsField"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotSubmittedOverlay", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotSubmittedOverlay"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "submitForm"), _class.prototype)), _class);
exports.default = ServiceForm;

function serverRender(service) {
  return "\n\t\t<div data-component='ServiceForm'>".concat(_server.default.renderToString(_react.default.createElement(ServiceForm, {
    service: service
  })), "</div>\n\t\t<script>\n\t\t\trequire('service-form').clientRender(").concat(JSON.stringify(service), ", document.querySelector('[data-component=ServiceForm]'));\n\t\t</script>\n\t");
}

function clientRender(service, node) {
  _reactDom.default.render(_react.default.createElement(ServiceForm, {
    service: service
  }), node);
}